module.exports = __webpack_public_path__ + "static/media/jo.3b53f058.png";